import React from "react";
import { Routes, Route } from "react-router-dom";
import { RequireAuth } from "./contexts/Auth/RequireAuth";
import Announcements from "./pages/Announcements/Announcements";
import GraphDiary from "./pages/GraphDiary";
import TeacherDiary from "./pages/TeacherDiary";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Stats from "./pages/Stats";
import Study from "./pages/Study";
import Grades from "./pages/Grades/Grades";
import Configure from "./pages/Configure/Configure";
import { Registration } from "./pages/Registration/Registration";
import { Integrante } from "./pages/Integrante/Integrante";
import Secretary from "./pages/Secretary/Secretary";
import GradeLogs from "./pages/GradeLogs/GradeLogs";
import ChangePassword from "./pages/ChangePassword/ChangePassword";
import Planning from "./pages/Planning/Planning";
import IndividualMessages from "./pages/IndividualMessages/IndividualMessages";
import Canteen from "./pages/Canteen/Canteen";
import Holerites from "./pages/RH/Holerites";
import EnrollmentCRM from "./pages/EnrollmentCRM/EnrollmentCRM";
import QuestionnaireAdmin from "./pages/Questionnaires/QuestionnaireAdmin";
import EventsAdmin from "./pages/Events/EventsAdmin";

const AllRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        path="/autentico/change-password"
        element={<ChangePassword />}
      />
      <Route
        path="/autentico/registration"
        element={
          <RequireAuth menu="registration">
            <Registration />
          </RequireAuth>
        }
      />

      <Route
        path="/autentico/secretary"
        element={
          <RequireAuth menu="secretary">
            <Secretary />
          </RequireAuth>
        }
      />
      <Route
        path="/autentico/teachers/diary"
        element={
          <RequireAuth menu="teacher_diary">
            <TeacherDiary />
          </RequireAuth>
        }
      />
      <Route
        path="/autentico/diary"
        element={
          <RequireAuth menu="diary">
            <GraphDiary />
          </RequireAuth>
        }
      />
      <Route
        path="/autentico/integrante"
        element={
          <RequireAuth menu="integrante">
            <Integrante />
          </RequireAuth>
        }
      />
      <Route
        path="/autentico/announcements"
        element={
          <RequireAuth menu="announcements">
            <Announcements />
          </RequireAuth>
        }
      />
      <Route
        path="/autentico/individual-messages"
        element={
          <RequireAuth menu="individual_messages">
            <IndividualMessages />
          </RequireAuth>
        }
      />
      <Route
        path="/autentico/study"
        element={
          <RequireAuth menu="study">
            <Study />
          </RequireAuth>
        }
      />
      <Route
        path="/autentico/grades"
        element={
          <RequireAuth menu="grades">
            <Grades />
          </RequireAuth>
        }
      />
      <Route
        path="/autentico/stats"
        element={
          <RequireAuth menu="stats">
            <Stats />
          </RequireAuth>
        }
      />
      <Route
        path="/autentico/questionnaires"
        element={
          <RequireAuth menu="questionnaires_admin">
            <QuestionnaireAdmin />
          </RequireAuth>
        }
      />
      <Route
        path="/autentico/events"
        element={
          <RequireAuth menu="events_admin">
            <RequireAuth menu="events_view">
              <EventsAdmin />
            </RequireAuth>
          </RequireAuth>
        }
      />
      <Route
        path="/autentico/config"
        element={
          <RequireAuth menu="config">
            <Configure />
          </RequireAuth>
        }
      />
      <Route
        path="/autentico/grades/logs"
        element={
          <RequireAuth menu="grade_logs">
            <GradeLogs />
          </RequireAuth>
        }
      />
      <Route
        path="/autentico/planning"
        element={
          <RequireAuth menu="planning">
            <Planning />
          </RequireAuth>
        }
      />
      <Route
        path="/autentico/canteen"
        element={
          <RequireAuth menu="canteen">
            <Canteen />
          </RequireAuth>
        }
      />
      <Route
        path="/autentico/rh/holerites"
        element={
          <RequireAuth menu="holerites">
            <Holerites />
          </RequireAuth>
        }
      />
      <Route
        path="/autentico/"
        element={
          <RequireAuth permition="all">
            <Login />
          </RequireAuth>
        }
      />
      <Route
        path="/autentico/home"
        element={
          <RequireAuth permition="all">
            <Home />
          </RequireAuth>
        }
      />
      <Route
        path="/autentico/crm-matriculas"
        element={
          <RequireAuth menu="enrollment_crm">
            <EnrollmentCRM />
          </RequireAuth>
        }
      />
    </Routes>
  );
};

export default AllRoutes;
